import { render } from "./SkinSlotC.vue?vue&type=template&id=be9fa8ec&scoped=true&ts=true"
import script from "./SkinSlotC.vue?vue&type=script&lang=ts"
export * from "./SkinSlotC.vue?vue&type=script&lang=ts"

import "./SkinSlotC.vue?vue&type=style&index=0&id=be9fa8ec&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9fa8ec"]])

export default __exports__